import {NgModule} from "@angular/core";
import {SharedModule} from "../../../shared.module";
import {SkinAnalyzerRoutingModule} from "./skin-analyzer-routing.module";
import {ProductResultsCardModule} from "../../product/results/product-results-card.module";
import {AnalyzerResultsComponent} from "./analyzer-results.component";
import { CreateShareListModalModule } from '../../social/create-share-list-modal/create-share-list-modal.module';

@NgModule({
    imports: [
        SharedModule,
        SkinAnalyzerRoutingModule,
        ProductResultsCardModule,
        CreateShareListModalModule
    ],
    providers: [],
    exports: [
        AnalyzerResultsComponent
    ],
    declarations: [
        AnalyzerResultsComponent
    ]
})
export class SkinAnalyzerResultsModule { }
